module.exports = "https://static.energy5.com/_next/static/images/step5Image-9f29641387d7f7d1a0a767094e648d5e.jpg";